import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "feedback", "wordCard"]

  connect() {
    // Initialize the controller
  }

  checkWord(event) {
    const index = event.currentTarget.dataset.index
    const inputTarget = this.inputTargets.find(target => target.dataset.index === index)
    const feedbackTarget = this.feedbackTargets.find(target => target.dataset.index === index)
    const correctWord = inputTarget.dataset.correctWord
    const userInput = inputTarget.value.trim().toLowerCase()
    
    feedbackTarget.classList.remove("hidden")
    
    if (userInput === correctWord.toLowerCase()) {
      feedbackTarget.textContent = "Correct! ✓"
      feedbackTarget.classList.remove("text-red-500")
      feedbackTarget.classList.add("text-green-500")
      inputTarget.classList.remove("border-red-500")
      inputTarget.classList.add("border-green-500")
    } else {
      feedbackTarget.textContent = "Incorrect! Try again."
      feedbackTarget.classList.remove("text-green-500")
      feedbackTarget.classList.add("text-red-500")
      inputTarget.classList.remove("border-green-500")
      inputTarget.classList.add("border-red-500")
    }
  }

  checkAllWords() {
    this.inputTargets.forEach((inputTarget, i) => {
      const index = inputTarget.dataset.index
      const feedbackTarget = this.feedbackTargets.find(target => target.dataset.index === index)
      const correctWord = inputTarget.dataset.correctWord
      const userInput = inputTarget.value.trim().toLowerCase()
      
      feedbackTarget.classList.remove("hidden")
      
      if (userInput === correctWord.toLowerCase()) {
        feedbackTarget.textContent = "Correct! ✓"
        feedbackTarget.classList.remove("text-red-500")
        feedbackTarget.classList.add("text-green-500")
        inputTarget.classList.remove("border-red-500")
        inputTarget.classList.add("border-green-500")
      } else {
        feedbackTarget.textContent = "Incorrect! The correct spelling is: " + correctWord
        feedbackTarget.classList.remove("text-green-500")
        feedbackTarget.classList.add("text-red-500")
        inputTarget.classList.remove("border-green-500")
        inputTarget.classList.add("border-red-500")
      }
    })
  }

  resetAllInputs() {
    this.inputTargets.forEach(inputTarget => {
      inputTarget.value = ""
      inputTarget.classList.remove("border-green-500", "border-red-500")
    })
    
    this.feedbackTargets.forEach(feedbackTarget => {
      feedbackTarget.classList.add("hidden")
      feedbackTarget.textContent = ""
    })
  }

  playWord(event) {
    const word = event.currentTarget.dataset.word
    
    if ('speechSynthesis' in window) {
      const utterance = new SpeechSynthesisUtterance(word)
      utterance.rate = 0.8 // Slightly slower rate for clarity
      speechSynthesis.speak(utterance)
    } else {
      alert("Sorry, your browser doesn't support text-to-speech!")
    }
  }

  revealWord(event) {
    const word = event.currentTarget.dataset.word
    const index = event.currentTarget.dataset.index
    const inputTarget = this.inputTargets.find(target => target.dataset.index === index)
    const feedbackTarget = this.feedbackTargets.find(target => target.dataset.index === index)
    
    inputTarget.value = word
    feedbackTarget.classList.remove("hidden")
    feedbackTarget.textContent = "Word revealed: " + word
    feedbackTarget.classList.remove("text-red-500", "text-green-500")
    feedbackTarget.classList.add("text-blue-500")
  }
} 